import { SubTitle } from './SubTitle';

export default SubTitle;